module.exports = __webpack_public_path__ + "static/magnify_data-e3c1aab5514502e47ce16015f34520cd.svg";